import humanizeDuration from "humanize-duration";

export function formatDate(date) {
  return new Intl.DateTimeFormat("US-en", {
    weekday: "long",
    year: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric",
    day: "numeric"
  }).format(date);
}

export function millisecondsToStr(ms) {
  return humanizeDuration(ms*1000, {
    round: true,
    largest: 2,
    units: ["d", "h", "m"]
  });
}

export function fromEpoch(epochSec) {
  return new Date(epochSec*1000)
}
